import React, { useState ,useEffect, useRef} from 'react';
import styles from './index.less';
import { Marquee } from 'zarm';
import Icon  from "@/components/Icon";

/**
 * [首页的头部组件]
 * text: 公告文本
 * textColor: 文本颜色
 * bgColor: 背景颜色
 */
const Notice = (props:any)=>{

  const {text, textColor, bgColor,scroll} = props;
  const [showMoreBtn ,setShowMoreBtn] = useState(false)

  const [showAllText ,setShowAlllText] = useState(false)

  const containerDom:any =  useRef()
  useEffect(()=>{
    // console.log(containerDom.current.scrollWidth , containerDom.current.clientWidth)
    if(containerDom.current.scrollWidth - containerDom.current.clientWidth>0){
      // setHeight(window.devicePixelRatio * 56) // 默认56px
      setShowMoreBtn(true)
    }
  },[])
  const defaultBgColor='rgba(255,175,0,0.1)'
  const defaultColor='rgba(255,175,0,1)'
  return <>
    {
      <div className={`${styles.noticeWrapper} `} style={{backgroundColor:bgColor?bgColor:defaultBgColor}} ref={containerDom}>
      {
        showMoreBtn===false ?
        <div className={`${styles.noticeText} ${styles.oneline}`} style={{color:textColor?textColor:defaultColor}}>{text}</div>
        :
        <div className={styles.toggleWrapper}>
          {
            showAllText===false?
            <>
              {
                scroll?
                <Marquee animationDelay={1000} animationDuration={30000} height={56} >
                  <div className={styles.noticeText} style={{color:textColor?textColor:defaultColor}}>{text}</div>
                </Marquee>:
                <div className={`${styles.noticeText}  ${styles.ellip}`} style={{color:textColor?textColor:defaultColor}}>{text}</div>
              }
            </>:
            <div className={`${styles.noticeText}`} style={{color:textColor?textColor:defaultColor}}>{props.text||props.notice}</div>
          }
          <div className={`${styles.rotateDown}  ${showAllText?styles.rotateUp :''}`} onClick={()=>{setShowAlllText(!showAllText)}}>
            <Icon
              type="order_selectdate_more"
              size="sm"
              color={textColor?textColor:defaultColor}
              />
          </div>
        </div>
      }
    </div>
    }
  </>
}

export default (Notice);
